import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { UploadedPhoto } from '../../prop-types';
import PhotoFilename from '../photo-filename';
import { PandaViewPreviewContainer } from '../panda-view-preview-container';
import { previewProps } from './preview-props';

const DuplicatePhotoBadge = () => (
  <span className="badge badge-warning mt-1 mr-1">Duplicate</span>
);

/**
 * @param {object} props
 * @param {object} props.photo - Photo object to display.
 * @param {boolean} props.isSelected - Whether the photo is selected.
 * @param {Function} props.onPhotoClick - Click handler for the photo.
 * @param {boolean} props.disabled - Whether prints builder updating is currently enabled or not.
 */
const DuplicatePhoto = ({
  photo,
  isSelected = false,
  disabled = false,
  onPhotoClick = () => {},
}) => {
  const inputId = `duplicate-selection--${photo.image_id}`;
  const srLabel = `Select ${photo.filename || 'this photo'} for removal`;

  const handleClick = () => {
    !disabled && onPhotoClick(photo.image_id);
  };

  const duplicateBadge = <DuplicatePhotoBadge />;
  const selectionCheckbox = (
    <div
      className="duplicate-selection-toggle mb-1 mr-1"
      onClick={(e) => e.stopPropagation()}>
      <label className="sr-only" htmlFor={inputId}>
        {srLabel}
      </label>
      <input
        disabled={disabled}
        id={inputId}
        type="checkbox"
        checked={isSelected}
        onChange={handleClick}
      />
    </div>
  );

  return (
    <div
      className={classNames(
        'duplicate-photos__photo',
        'duplicate-photos__duplicate-photo',
        { 'duplicate-photos__photo--selected': isSelected },
      )}>
      <PhotoFilename photo={photo} className="mb-0" />

      <div
        className="duplicate-photos__duplicate-photo-preview list-item__preview mb-0"
        onClick={handleClick}
        role="button"
        aria-label={srLabel}
        aria-pressed={isSelected}
        tabIndex={0}
        onKeyDown={(e) =>
          (e.key === 'Enter' || e.key === ' ') && handleClick()
        }>
        <PandaViewPreviewContainer
          {...photo}
          {...previewProps(photo)}
          topRightOverlay={duplicateBadge}
          bottomRightOverlay={selectionCheckbox}
        />
      </div>
    </div>
  );
};

DuplicatePhoto.propTypes = {
  photo: UploadedPhoto.isRequired,
  isSelected: PropTypes.bool,
  disabled: PropTypes.bool,
  onPhotoClick: PropTypes.func,
};

export { DuplicatePhoto };
